import { message } from "antd";
import { token } from "../../constants/Constants";
import { get_all_tests } from "../../endpoints/API";

export const fetchTest = async (setTest, baseUrl, prodTestUrl) => {
  try {
    const response = await get_all_tests();
    if (response.statusText=="OK") {
      const data = response?.data;
      setTest(data);
    } else {
      message.error("Failed to fetch test.");
      setTest([]);
    }
  } catch (error) {
    message.error(error?.response?.data?.error||"An error occurred while fetching test.");
  }
};
